@if (showSpinner) {
  <div id="spinner">
    <div class="modal-film">
      <div class="spinner-panel">
        <img class="spinner-image" src="../../../../../assets/clear-spinner.gif" alt="Spinner image" />
      </div>
    </div>
  </div>
}
